module.exports = __webpack_public_path__ + "img/logoalma.2055c7c9.png";